import { combine, createEvent, createStore, sample } from 'effector'
import { $goodsFiltered } from 'src/features/filter-goods/model/goods-result'
import { useEvent, useStore } from 'effector-react'
import { onRouteChangeComplete } from '@entities/route/model'
import { goodsCountOnPage } from '@styles/theme-const'

const onSelectedPage = createEvent<number>()

const $pageCount = createStore<number>(0)

const $currentPage = createStore(1)

sample({
    clock: onRouteChangeComplete,
    target: $currentPage.reinit!
})

export const $paginationGoods = combine(
    {
        goodsFiltered: $goodsFiltered,
        currentPage: $currentPage
    },
    ({ goodsFiltered, currentPage }) => {
        if (!goodsFiltered || goodsFiltered.length === 0) return []
        const factor = currentPage > 0 ? currentPage - 1 : 1
        const startNumberGoods = factor * goodsCountOnPage
        const goodsVisible = goodsFiltered.slice(startNumberGoods, startNumberGoods + goodsCountOnPage)
        return goodsVisible
    }
)

export const pickupPagination = createEvent()

sample({
    clock: $goodsFiltered,
    target: pickupPagination
})

sample({
    clock: $goodsFiltered,
    source: $goodsFiltered,
    fn: (goods) => (goods?.length > 0 ? Math.ceil(goods.length / goodsCountOnPage) : 0),
    target: $pageCount
})

sample({
    clock: onSelectedPage,
    target: $currentPage
})

sample({
    clock: $pageCount,
    filter: (number) => number <= 0,
    fn: () => 1,
    target: $currentPage
})

export const usePageCount = () => useStore($pageCount)
export const useCurrentPage = () => useStore($currentPage)
export const useOnSelectedPage = () => useEvent(onSelectedPage)
